import styled from 'styled-components';
import React from 'react';
import {
  Button,
  SectionParent,
  H1,
  H2,
  BlueButton,
} from '../../StyledComponents';
// import Arrow from '../../../assets/v2/homepagedevsection/arrow.svg';
// import DeveloperHero from '../../../assets/v2/png/developer_hero.svg';
import { navigate } from 'gatsby';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Title } from '../HomePage/HomepageSectionOne';
import Api from '../../../assets/v2/Developer/Api.svg';
import Cli from '../../../assets/v2/Developer/Cli.svg';
import Lab from '../../../assets/v2/Developer/Lab.svg';
import Os from '../../../assets/v2/Developer/Os.svg';
// import Hero from '../../lottieAnimations/Hero.json'
// import lottie, { AnimationItem } from 'lottie-web';

const AndroidTitle = styled(Title)`
  color: #66d1b1;
  font-size: 36px;
  line-height: normal;
  font-weight: bold;
  text-align: center;
  margin-top: 5rem;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    text-align: center;
  }
`;

const FromManufacturingT = styled.h2`
  font-size: 18px;
  line-height: normal;
  color: #d1d7ea;
  text-align: center;
  width: 60%;
  margin-left: 20%;
  margin-top: 16px;
  @media (max-width: 1700px) {
    font-size: 18px;
  }
  @media (max-width: 1440px) {
    font-size: 18px;
  }
  @media (max-width: 1024px) {
    font-size: 18px;
  }
  @media (max-width: 768px) {
    font-size: 16px;
    width: 80%;
    margin-left: 10%;
    text-align: center;
  }
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 400;
  @media (max-width: 520px) {
    /* margin-bottom: -50%; */
    width: 100%;
    padding: 0 3rem;
    line-height: 1.5;
    margin-left: 0;
  }
  @media (max-width: 375px) {
    padding: 0 1rem;
  }
`;

const SectionAndroid = styled(SectionParent)`
  background: #0f1a3e;
  padding-top: 1rem !important;
  padding-bottom: 2rem !important;
  @media (max-width: 520px) {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  @media (min-width: 1500px) {
    margin-left: 5rem;
  }
`;
const Grid = styled.div`
  display: grid;
  padding-bottom: 3rem;
  padding-top: 2rem;
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 700px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 520px) {
    padding-bottom: 1rem;
  }
  @media (min-width: 1500px) {
    width: 115%;
    margin-left: 2rem;
  }
`;
const GridItem = styled.div`
  justify-self: center;
  max-width: 80%;
  align-self: center;
  grid-column: span 2;
  margin-left: 4rem;
  @media (max-width: 768px) {
    margin-right: 0rem;
  }
  @media (max-width: 700px) {
    grid-column: span 3;
    display: grid;
    margin-right: 0rem;
    justify-items: center;
  }
`;
const SectionAndroidContent = styled(H2)`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #99bee3;
  width: 100%;
  padding-top: 0.5rem;
  text-align: justify;
  // margin-left: 2.5rem;
  img {
    margin-top: 1rem;
  }
  @media (max-width: 700px) {
    padding-left: 0;
    text-align: justify;
    width: 90%;
  }
  @media (max-width: 520px) {
    width: 120%;
    text-align: center;
    margin-right: 4rem;
    margin-bottom: 1rem;
    font-size: 14px;
  }
  @media (min-width: 1500px) {
    font-size: 16px;
    width: 80%;
  }
`;
const SectionTitle = styled(H1)`
  font-size: 28px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  @media (max-width: 520px) {
    text-align: center;
    margin-right: 4rem;
  }
`;

const TargetImage = styled(LazyLoadImage)`
  width: 550px;
  margin-top: 2rem;
  justify-self: center;
  @media (max-width: 768px) {
    width: 90%;
    margin-top: 0;
  }
  @media (min-width: 1500px) {
    width: 170%;
  }
`;

const TargetImageOS = styled(LazyLoadImage)`
  width: 362px;
  margin-top: 2rem;
  justify-self: center;
  @media (max-width: 768px) {
    width: 90%;
    margin-top: 0;
  }
`;

const ImgWrapper = styled.div`
  display: grid;
  align-items: center;
  margin-left: 3rem;
  margin-bottom: 2rem;
  @media (max-width: 768px) {
    grid-column: span 2;
  }
  @media (max-width: 700px) {
    grid-column: span 3;
  }
  @media (max-width: 520px) {
    padding-bottom: 2rem;
    margin: 0 auto;
  }
`;

const CloudButtonWrapper = styled.div`
  /* margin-top: -6rem; */
  justify-content: left;
  display: flex;
  margin-top: 10px;
  margin-bottom: 0rem;
  @media (max-width: 768px) {
    justify-self: center;
    margin-top: 0;
    margin-right: 0rem;
  }
  @media (max-width: 520px) {
    margin-top: 1rem;
    margin-bottom: 1rem;
    margin-left: 0.5rem;
    margin-right: 0rem;
  }
`;

const GreenButtonNew = styled(BlueButton)`
  background: #02b875;
  width: 100% @media (max-width: 520px) {
    font-size: 16px;
  }
  @media (max-width: 320px) {
    font-size: 14px;
  }
`;

export class Cloud extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      width: 0,
      height: 0,
      first: true,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    return (
      <div>
        <AndroidTitle>Full-Stack Developer Tools for Android</AndroidTitle>
        <FromManufacturingT>
          Automate your Android app development and device management for the
          cloud age.
          <br />
          <br />
          Esper’s full-stack cloud developer tools help you build, deploy, and
          <br />
          debug cloud-connected apps running on Android devices.
        </FromManufacturingT>
        <SectionAndroid>
          {this.state.width > 678 ? (
            <Grid>
              <ImgWrapper
                style={
                  this.state.width > 1500
                    ? {
                        marginRight: '8rem',
                        marginLeft: '-6rem',
                      }
                    : { display: 'grid' }
                }
              >
                <TargetImage
                  style={this.state.width > 1500 ? { width: '170%' } : {}}
                  src={Api}
                />
              </ImgWrapper>
              <GridItem>
                <SectionTitle>Cloud API</SectionTitle>
                <SectionAndroidContent>
                  Esper offers a complete set of rich, open APIs for app and
                  dedicated device management actions.
                  <br />
                  <br />
                  Automate your fleet deployment and management activities or
                  build your own custom-tailored DevOps dashboard.
                </SectionAndroidContent>
                <CloudButtonWrapper>
                  <a href="https://docs.esper.io/home/api.html">
                    <GreenButtonNew>Learn More</GreenButtonNew>
                  </a>
                </CloudButtonWrapper>
              </GridItem>
            </Grid>
          ) : (
            <Grid>
              <GridItem>
                <SectionTitle>Cloud API</SectionTitle>
                <SectionAndroidContent>
                  Esper offers a complete set of rich, open APIs for app and
                  dedicated device management actions.
                  <br />
                  <br />
                  Automate your fleet deployment and management activities or
                  build your own custom-tailored DevOps dashboard.
                </SectionAndroidContent>
              </GridItem>
              <ImgWrapper>
                <TargetImage src={Api} />
                <CloudButtonWrapper>
                  <a href="https://docs.esper.io/home/api.html">
                    <GreenButtonNew>Learn More</GreenButtonNew>
                  </a>
                </CloudButtonWrapper>
              </ImgWrapper>
            </Grid>
          )}
          {this.state.width > 678 ? (
            <Grid>
              <GridItem
                style={
                  this.state.width > 1500
                    ? {
                        marginRight: '8rem',
                        marginLeft: '-15rem',
                      }
                    : { justifyContent: 'center' }
                }
              >
                <SectionTitle>Esper CLI</SectionTitle>
                <SectionAndroidContent>
                  A unified command line interface to the Esper APIs, provided
                  with source code.
                </SectionAndroidContent>
                <CloudButtonWrapper>
                  <a href="https://docs.esper.io/home/espercli.html">
                    <GreenButtonNew>Get Started</GreenButtonNew>
                  </a>
                </CloudButtonWrapper>
              </GridItem>
              <ImgWrapper
                style={
                  this.state.width > 1500
                    ? {
                        marginRight: '10rem',
                        marginLeft: '-4rem',
                      }
                    : { display: 'grid' }
                }
              >
                <TargetImage
                  style={this.state.width > 1500 ? { width: '210%' } : {}}
                  src={Cli}
                />
              </ImgWrapper>
            </Grid>
          ) : (
            <Grid>
              <GridItem>
                <SectionTitle>Esper CLI</SectionTitle>
                <SectionAndroidContent>
                  A unified command line interface to the Esper APIs, provided
                  with source code.
                </SectionAndroidContent>
              </GridItem>
              <ImgWrapper>
                <TargetImage src={Cli} />
                <CloudButtonWrapper>
                  <a href="https://docs.esper.io/home/espercli.html">
                    <GreenButtonNew>Get Started</GreenButtonNew>
                  </a>
                </CloudButtonWrapper>
              </ImgWrapper>
            </Grid>
          )}
          {this.state.width > 678 ? (
            <Grid>
              <ImgWrapper
                style={
                  this.state.width > 1500
                    ? {
                        marginRight: '8rem',
                        marginLeft: '-6rem',
                      }
                    : { display: 'grid' }
                }
              >
                <TargetImage
                  style={this.state.width > 1500 ? { width: '150%' } : {}}
                  src={Lab}
                />
              </ImgWrapper>
              <GridItem>
                <SectionTitle>Virtual Device Lab</SectionTitle>
                <SectionAndroidContent>
                  Simulate real-world performance of devices, apps,
                  configurations, and peripherals.
                  <br />
                  <br />
                  Improve test and performance optimization at each stage of the
                  product development lifecycle.
                </SectionAndroidContent>
                <CloudButtonWrapper>
                  <a href="https://esper.io/test-lab/">
                    <GreenButtonNew>It's Free to Start</GreenButtonNew>
                  </a>
                </CloudButtonWrapper>
              </GridItem>
            </Grid>
          ) : (
            <Grid>
              <GridItem>
                <SectionTitle>Virtual Device Lab</SectionTitle>
                <SectionAndroidContent>
                  Simulate real-world performance of devices, apps,
                  configurations, and peripherals.
                  <br />
                  <br />
                  Improve test and performance optimization at each stage of the
                  product development lifecycle.
                </SectionAndroidContent>
              </GridItem>
              <ImgWrapper>
                <TargetImage src={Lab} />
                <CloudButtonWrapper>
                  <a href="https://esper.io/test-lab/">
                    <GreenButtonNew>It's Free to Start</GreenButtonNew>
                  </a>
                </CloudButtonWrapper>
              </ImgWrapper>
            </Grid>
          )}
          {this.state.width > 678 ? (
            <Grid>
              <GridItem
                style={
                  this.state.width > 1500
                    ? {
                        marginRight: '8rem',
                        marginLeft: '-15rem',
                      }
                    : { justifyContent: 'center' }
                }
              >
                <SectionTitle>Android OS for Device Fleets</SectionTitle>
                <SectionAndroidContent>
                  Esper Enhanced Android (EEA) is a purpose-built operating
                  system for smart Android fleets.
                  <br />
                  <br />
                  EEA removes consumer-grade software and adds security, easier
                  provisioning, and rich remote debugging.
                </SectionAndroidContent>
                <CloudButtonWrapper>
                  <GreenButtonNew onClick={() => navigate('/signup')}>
                    Sign Up
                  </GreenButtonNew>
                </CloudButtonWrapper>
              </GridItem>
              <ImgWrapper
                style={
                  this.state.width > 1500
                    ? {
                        marginRight: '10rem',
                        marginLeft: '0rem',
                      }
                    : { display: 'grid' }
                }
              >
                <TargetImageOS
                  style={this.state.width > 1500 ? { width: '210%' } : {}}
                  src={Os}
                />
              </ImgWrapper>
            </Grid>
          ) : (
            <Grid>
              <GridItem>
                <SectionTitle>Android OS for Device Fleets</SectionTitle>
                <SectionAndroidContent>
                  Esper Enhanced Android (EEA) is a purpose-built operating
                  system for smart Android fleets.
                  <br />
                  <br />
                  EEA removes consumer-grade software and adds security, easier
                  provisioning, and rich remote debugging.
                </SectionAndroidContent>
              </GridItem>
              <ImgWrapper>
                <TargetImageOS src={Os} />
                <CloudButtonWrapper>
                  <GreenButtonNew onClick={() => navigate('/signup')}>
                    Sign Up
                  </GreenButtonNew>
                </CloudButtonWrapper>
              </ImgWrapper>
            </Grid>
          )}
        </SectionAndroid>
      </div>
    );
  }
}

export default Cloud;
